import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import MarketingLayout from './MarketingLayout';
import { GlobalLayout } from '../../appChunks';

/**
 * MarketingRoute — chooses the shell for a public marketing page:
 *  - Logged OUT → MarketingLayout (top header, no sidebar, dark-only).
 *  - Logged IN  → GlobalLayout (the normal app shell, unchanged) — lazy from
 *    the app-core chunk (CEL-1086 bundle split), so logged-out marketing/SEO
 *    visitors never download the authenticated app.
 */
const MarketingRoute = ({ children }) => {
  const { currentUser } = useAuth();
  if (currentUser) {
    return <GlobalLayout>{children}</GlobalLayout>;
  }
  return <MarketingLayout>{children}</MarketingLayout>;
};

export default MarketingRoute;
